/* Copyright (c) 2026 Xperi. All Rights Reserved. */

// The engine is the module's only export (DRD 2.4). Its helpers —
// RatingTaxonomy, ParentalSettingsParser, ParentalSettingsSerializer and
// PinHashVerifier — are internal; public types live in model/types and
// model/enums.
export { ParentalRuleEngine } from "./ParentalRuleEngine";
export type { TParentalRuleEngineDependencies } from "./ParentalRuleEngine";
